export default () => ({
    root: {
        flexShrink: 0,
        color: 'white',
        marginLeft: 10
    }
});
